import type { SchemaField } from '@cli-types/core-engine/schema.js'

export function ensureTabFields(tab: NonNullable<SchemaField['tabs']>[number]): SchemaField[] {
  if (!Array.isArray(tab.fields)) {
    tab.fields = []
  }
  return tab.fields
}
